import { useSelector } from "react-redux";
import PropertySingle from "../../propertyNew/PropertySingle";
import PropertyNotes from "../../../components/notes/PropertyNotes";

const PropertyCustomerDetail = ({ backPath = "/customer/properties" }) => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const userType = loggedInUser?.user?.userType?.name;

  return ( 
    <div className="mb-4 pb-4"> 
      <PropertySingle 
        backBtn={backPath}
      />
      {userType === "PARTNER" && (
        <div className="container-fluid px-0 mt-3" style={{ maxWidth: "1200px" }}>
          <PropertyNotes />
        </div>
      )}
    </div>
  );
};

export default PropertyCustomerDetail;
